import http from './HttpService';

export default {
  async getLineDetails (digitableLine) {
    const url = `/api/v1/billets/${digitableLine}/detail/`;
    const res = await http().get(url, {});
    return res.data.data;
  },
};
